//#################### Path :: app/scripts/restrictedAreaNotice.js//####################
$(function () {
    $(document).on('restricted_area', function(e, inRestrictedArea){
        if(inRestrictedArea)
            $('#restrictedAreaNotice').css('display', 'block');
        else
            $('#restrictedAreaNotice').css('display', 'none');
    });
});


